import type { Screen } from '@ghostscreen/contracts';
import { getCardConnectionStatus, getCardSyncStatus } from './screenStatus';

/**
 * Operator-facing status for the mobile companion.
 * Maps technical connection/sync into three plain states (+ not connected).
 */
export type OperatorDisplayStatus = 'connected' | 'offline' | 'syncing' | 'not-connected';

/** Keys in the `common` namespace. */
export const OPERATOR_DISPLAY_STATUS_LABEL_KEY = {
  connected: 'operatorStatus.connected',
  offline: 'operatorStatus.offline',
  syncing: 'operatorStatus.syncing',
  'not-connected': 'operatorStatus.notConnected',
} as const satisfies Record<OperatorDisplayStatus, string>;

export function getOperatorDisplayStatus(screen: Screen): OperatorDisplayStatus {
  const connection = getCardConnectionStatus(screen);
  if (connection === 'unpaired') return 'not-connected';
  if (connection === 'offline' || connection === 'unknown') return 'offline';

  const sync = getCardSyncStatus(screen);
  if (sync === 'outdated') return 'syncing';

  return 'connected';
}
